import { DateTimeType } from './dateTypes';
import { z } from 'zod';

export const Deductions = z.object({
    validFrom: DateTimeType,
    validTo: DateTimeType,
    breakfast: z.number(),
    lunch: z.number(),
    dinner: z.number(),
});
export type Deductions = z.infer<typeof Deductions>;
